import React, { useEffect, useState } from 'react';
import { Button, Col, Collapse, Form, Input, message, Row, Skeleton, Upload } from 'antd';
import { API_FETCH } from '../../../../utils';
import { AiOutlineUpload } from 'react-icons/ai';
import { useGlobalState } from '../../../../store/state';
import { SubmitCampaignCreatives } from '../../../../apis/Influencer/Campaigns/SubmitCampaignCreatives';
import './CampaignCreativeCollectionForm.styles.scss';
// import { GetSubmittedCreatives } from '../../../../apis/Influencer/Campaigns/GetSubmittedCreatives'
import { useHistory } from 'react-router-dom';

const { Panel } = Collapse;
const { Item } = Form;
const { Dragger, LIST_IGNORE } = Upload;
const { TextArea } = Input;


const CampaignCreativeCollectionForm = ({ deliverables, campId }) => {
  const history = useHistory();
  const [user] = useGlobalState('user');
  const [loading, setLoading]= useState(true);
  const uploadProps = {
    name: 'filename',
    listType: 'picture',
    FileList: 'fileList',
    accept: 'image/png, image/jpg, image/jpeg, application/pdf, video/mp4, application/msword',
    multiple: false,
    beforeUpload: (info) =>{
      if (
        info.type === 'image/png' ||
                info.type === 'image/jpg' ||
                info.type === 'image/jpeg'||
                info.type === 'video/mp4'||
                info.type === 'application/pdf' ||
                info.type === 'application/msword'
      ) {
        // message.info(`${info.name} file ready to upload!`);
        return info;
      } else {
        message.error(`${info.name} is not a supported file type`);
        return LIST_IGNORE;
      }
    },
    customRequest: function (componentsData) {
      // console.log("inputdata",componentsData)
      const formData = new FormData();
      const _reqHeader = new Headers();
      _reqHeader.append('Authorization', `Bearer ${user.accessToken}`);
      formData.append('creative', componentsData.file);
      fetch(API_FETCH(`/influencer/campaign/${campId}/creatives/image`), {
        method: 'POST',
        headers: _reqHeader,
        body: formData,
        redirect: 'follow',
      })
        .then((response) => response.json())
        .then((result) => componentsData.onSuccess(result));
    },
  };
  const normFile = (e) =>{
    if (e.fileList.length > 1) {
      return [e.fileList[1]];
    } else {
      return e && e.fileList;
    }
  };

  const creativesSubmission = (values) => {
    console.log('submission data', values);

    // @note: base model
    const creatives = [];
    for (let i = 0; i < deliverables.length; i++) {
      creatives.push({
        creativeid: values[`creativeid_`+i],
        creativedata: [],
      });
      for (let k = 0; k < deliverables[i].creatives; k++) {
        creatives[i].creativedata.push({
          title: values[`title_${i}_${k}`],
          content: values[`content_${i}_${k}`],
          asset: values[`asset_${i}_${k}`] ? values[`asset_${i}_${k}`][0].response.response : values[`asset_${i}_${k}`],
        });
      }
    }
    console.log('mock', creatives);
    // @note: connecting to data
    // todo: awating correction asset data
    const _data = {
      campaignid: campId,
      creatives: creatives,
    };
    console.log('sss', _data);
    SubmitCampaignCreatives(user.accessToken, _data).then(({ status, response })=>{
      console.log('API: after submit creative', response);
      if (status === 200) {
        message.success('Creatives Submitted Successfully');
        // getCreativeAfterSubmit()
        history.push(`/influencer/campaigns/${campId}/creatives/review`);
      } else {
        message.error('There some issue while submitting your creative');
      }
    });
  };
  useEffect(()=>{
    setLoading(false);
  }, []);
  return (
    <div>
      <Form
        layout="vertical"
        // requiredMark={false}
        name="creativesSubmitForm"
        onFinish={creativesSubmission}
        initialValues={{

        }}
      >
        <Collapse
          className="acc_campaign mb-2 common_collapse"
          showArrow={false}
          defaultActiveKey={[1, 2, 3, 4]}
        >
          {
            deliverables.map(({ format, creatives, _id }, index)=>(
              <Panel key={index+1}
                showArrow={false}
                header={
                  <h3 >Creative #{index + 1}</h3>
                }
              >
                <ul className="cc_preview_each_basics">
                  <li>
                    <p>Task Type</p>
                    <h6>{format}</h6>
                  </li>
                  <li>
                    <p>No. of posts</p>
                    <h6>{creatives}</h6>
                  </li>
                </ul>
                <Item
                  name={`creativeid_`+index}
                  hidden={true}
                  initialValue={_id}
                >
                  <Input type="hidden" />
                </Item>

                {
                  [...Array(creatives).keys()].map((creative)=>(
                    <div key={_id+creative}
                      className="creativePosts_each">
                      <div className="creativePosts_each_count"><span>{creative+1}</span>/{creatives}</div>
                      <Row gutter={12}>
                        <Col span={14}>

                          <Item
                            name={`title_${index}_${creative}`}
                            label="Post Title"
                            rules={[{ required: true, message: 'This can\'t be empty' }]}
                          >
                            <Input className="common_input"
                              type="text"
                              size="large"
                              placeholder="Eg: New product lauch do check"/>
                          </Item>
                          <Item
                            name={`content_${index}_${creative}`}
                            label="Post Description"
                            rules={[{ required: true, message: 'This can\'t be empty' }]}
                          >
                            <TextArea className="common_input"
                              rows={6}
                              placeholder="Describe your post with suggested keyowrds, Also use hashtags and mentions..."/>
                          </Item>
                        </Col>
                        <Col span={10}>
                          <Item
                            name={`asset_${index}_${creative}`}
                            label="Upload Creative"
                            valuePropName="fileList"
                            getValueFromEvent={normFile}
                            rules={[{ required: true, message: 'This can\'t be empty' }]}
                          >
                            <Dragger {...uploadProps}
                              style={{ width: '100%' }}>
                              <p className="text-center svg-icon">
                                <AiOutlineUpload size={24} />
                              </p>
                              <p className="ant-upload-text"><strong>Click or Drag & Drop</strong><br/>your file here to upload</p>
                              <p className="ant-upload-hint">Supports png/jpg,jpeg,pdf,doc,mp4</p>
                            </Dragger>
                          </Item>
                        </Col>
                      </Row>
                    </div>
                  ))
                }
              </Panel>
            ))
          }

        </Collapse>
        <div className="text-right">

          <Button
            className="common_button"
            title="Submit your All creatives"
            htmlType="submit"
          >Submit All Creatives</Button>
        </div>
      </Form>
    </div>
  );
};

export default CampaignCreativeCollectionForm;
